module.exports = __webpack_public_path__ + "static/media/obdulias-business-inn.2888ee2c.jpg";